module.exports = __webpack_public_path__ + "assets/img/27_1435.4dcdf644.jpg";